import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'react-bootstrap';

interface ViewButtonComponentProps {
  visible: boolean;
  onClick: () => void;
}

const ViewButtonComponentV2: React.FC<ViewButtonComponentProps> = ({ visible, onClick }) => {
  return (
    <Button variant='light' size='sm' onClick={onClick}>
      <FontAwesomeIcon
        icon={visible ? faEye : faEyeSlash}
        color={visible ? '#FF9A62' : undefined}
      />
    </Button>
  );
};

export default ViewButtonComponentV2;
